<template>
    <div id="app">
        <pageHeader />
        <router-view></router-view>
        <login-dialog />
        <pageFooter/>

    </div>
</template>
<script>
import pageHeader from "@/components/pageHeader/index.vue";
import pageFooter from "@/components/pageFooter/index.vue";
import LoginDialog from "@/components/login/index.vue";

export default {
    components: {pageHeader,pageFooter, LoginDialog},
    data() {
        return {
          currentPath: '',
        }
    },
    name: 'app',
    mounted() {
      this.currentPath = window.location.hash;
    },
    computed: {
      isHomePage() {
        return this.$route.path === '/home';
      }
    },
    methods: {

    },
    watch: {
      '$route'(to) {
        this.currentPath = to.path;
        console.log(this.currentPath);
      }
    }
}
</script>
<style lang="scss">
/*-----------------[初始化]--------------*/
*, *:before, *:after {
    margin: 0;
    padding: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
}

html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
}

article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    display: block;
}

ol, ul {
    list-style: none;
}

blockquote, q {
    quotes: none;
}

blockquote:before, blockquote:after, q:before, q:after {
    content: "";
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

body {
    color: #3d4c63;
    background: #fff;
    font: 14px/1.5 "Microsoft Yahei", sans-serif;
    outline: 0;
}

a {
    color: #333;
    text-decoration: none;
}

a:hover {
    color: inherit;
}

img {
    max-width: 100%;
    border: none;
}

em, i {
    font-style: normal;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

input, textarea, select {
    font-size: 12px;
    color: #444;
    font-family: "Microsoft Yahei", sans-serif;
    outline: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -o-box-sizing: border-box;
    box-sizing: border-box;
}

input[type="submit"], input[type="reset"], input[type="button"], select, button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

input[type="submit"], input[type="reset"], input[type="button"], button {
    cursor: pointer;
}

.false:focus {
    border: 2px solid #ff1531;
    background: #fff;
}

::-webkit-input-placeholder {
    color: #999;
}

::-moz-placeholder {
    color: #999;
}

:-ms-input-placeholder {
    color: #999;
}

/* 去掉 IE10+ 密码框默认小眼睛、输入框 X */
::-ms-clear, ::-ms-reveal {
    display: none;
}

::-webkit-scrollbar { width: 2px;
    height: 14px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #10AAC2;border-radius: 2px }
::-webkit-scrollbar-thumb:window-inactive { background: #10AAC2;border-radius: 2px }

.el-table th.el-table__cell > .cell{
    font-weight: bold;
    font-size: 14px;
    color: #333333;
}
.el-table__footer{
    .cell{
        font-weight: bold;
        font-size: 14px;
        color: #10AAC2;
    }
}

</style>
